// extracted by mini-css-extract-plugin
module.exports = {"card-title":"style_card-title__nGOeT"};